(function() {
    const HOVER_DELAY = 250; // ms
    const CAN_HOVER = window.matchMedia
        ? window.matchMedia('(hover: hover) and (pointer: fine)').matches
        : !('ontouchstart' in window) && navigator.maxTouchPoints === 0;
    let activeDropdown = null;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        initDropdowns();
        initIsStuckClass();
        document.addEventListener('click', handleDocumentClick);
    }

    function initDropdowns() {
        const dropdowns = document.querySelectorAll('.nav-item.dropdown');

        dropdowns.forEach((item) => {
            const link = item.querySelector('.nav-link');
            const dropdownMenu = item.querySelector('.dropdown-menu');

            if (!link || !dropdownMenu) return;

            let openTimeout, closeTimeout;

            // Desktop hover behavior
            item.addEventListener('mouseenter', function() {
                if (!CAN_HOVER) return;

                clearTimeout(closeTimeout); // prevent closing if re-entered quickly
                openTimeout = setTimeout(function() {
                    openDropdown(item, link, dropdownMenu);
                }, HOVER_DELAY);
            });

            item.addEventListener('mouseleave', function() {
                if (!CAN_HOVER) return;

                clearTimeout(openTimeout); // prevent opening if leaving quickly
                closeTimeout = setTimeout(function() {
                    closeDropdown(item, link, dropdownMenu);
                }, HOVER_DELAY);
            });

            // Mobile click behavior
            link.addEventListener('click', function(e) {
                if (CAN_HOVER) return;

                const isVisible = dropdownMenu.classList.contains('show');

                if (!isVisible) {
                    // First tap: open dropdown instead of following link
                    e.preventDefault();
                    openDropdown(item, link, dropdownMenu);
                } else {
                    // Second tap: allow navigation to proceed normally
                    closeDropdown(item, link, dropdownMenu);
                }
            });
        });
    }

    // Handle adding/removing CSS class to navbar when it's stuck/unstuck
    function initIsStuckClass() {
        const navbarContainer = document.getElementById('site-navbar-container');
        if (navbarContainer && navbarContainer.classList.contains('navbar-behavior-sticky')) {
            const navbarObserver = new IntersectionObserver(function([e]) {
                e.target.classList.toggle('is-stuck', e.intersectionRatio < 1);
            }, {
                threshold: [1],
                rootMargin: '-1px 0px 0px 0px'
            });
            navbarObserver.observe(navbarContainer);
        }
    }

    // Close any open dropdowns when clicking elsewhere
    function handleDocumentClick(e) {
        if (!e.target.closest('.nav-item.dropdown')) {
            closeActiveDropdown();
        }
    }

    // Helper functions
    function openDropdown(item, link, menu) {
        if (activeDropdown && activeDropdown.item !== item) {
            closeDropdown(activeDropdown.item, activeDropdown.link, activeDropdown.menu);
        }

        link.classList.add('show');
        menu.classList.add('show');
        activeDropdown = { item, link, menu };
    }

    function closeDropdown(item, link, menu) {
        link.classList.remove('show');
        menu.classList.remove('show');

        if (activeDropdown && activeDropdown.item === item) {
            activeDropdown = null;
        }
    }

    function closeActiveDropdown() {
        if (!activeDropdown) return;

        closeDropdown(activeDropdown.item, activeDropdown.link, activeDropdown.menu);
    }
})();